import { Model } from '@vuex-orm/core'

export default class Approvalflow extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'approvalflows'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      status: this.attr(null),
      job_id: this.attr(null),
      requisition_id: this.attr(null),
      groups: this.attr(null),
      requires_my_approval: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Approvalflow.js